import { REPOSITION_DESIGN } from "../../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case REPOSITION_DESIGN:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          if (
            old_layer.width > 0 &&
            (old_layer.allow_image || old_layer.allow_text)
          ) {
            const layerWidth = old_layer.width,
              layerHeight = old_layer.height;

            return {
              ...old_layer,
              text_elements: old_layer.text_elements.map((element) => {
                let elLeft = element.left_position,
                  elTop = element.top_position;

                const totalElWidth = element.width + element.left_position,
                  totalElHeight = element.height + element.top_position;

                // If outside the bounds of the printable area, move it back within bounds
                if (totalElWidth > layerWidth) {
                  elLeft -= totalElWidth - layerWidth;
                } else if (element.left_position < 0) {
                  elLeft = 0;
                }

                if (totalElHeight > layerHeight) {
                  elTop -= totalElHeight - layerHeight;
                } else if (element.top_position < 0) {
                  elTop = 0;
                }

                return {
                  ...element,
                  left_position: elLeft,
                  top_position: elTop,
                };
              }),
              image_elements: old_layer.image_elements.map((element) => {
                let elLeft = element.left_position,
                  elTop = element.top_position;

                const totalElWidth = element.width + element.left_position,
                  totalElHeight = element.height + element.top_position;

                // If outside the bounds of the printable area, move it back within bounds
                if (totalElWidth > layerWidth) {
                  elLeft -= totalElWidth - layerWidth;
                } else if (element.left_position < 0) {
                  elLeft = 0;
                }

                if (totalElHeight > layerHeight) {
                  elTop -= totalElHeight - layerHeight;
                } else if (element.top_position < 0) {
                  elTop = 0;
                }

                return {
                  ...element,
                  left_position: elLeft,
                  top_position: elTop,
                };
              }),
            };
          } else {
            return {
              ...old_layer,
            };
          }
        }),
      };

    default:
      return state;
  }
}
